import { ACCOUNT_DETAILS_PATH, OVPN_PATH } from '../../constants';

import { encodeSegment as seg } from './url';

// Single source of truth for endpoint paths (relative to API_BASE). Static
// strings are consumed directly by buildUrl; builders encode their dynamic
// segments. Trailing slashes and shapes are reproduced exactly as the prior
// flat api.js emitted them, so request URLs are byte-identical.
export const PATHS = {
    // Labs
    labs: '/labs',
    lab: (id) => `/labs/${seg(id)}`,
    labInstructions: (labId) => `/instructions/${seg(labId)}`,
    labKeys: '/labscerts',
    labProducts: '/lab_products',
    accountDetails: `/${ACCOUNT_DETAILS_PATH}`,
    ovpnCert: (labId) => `/${OVPN_PATH}/${seg(labId)}`,
    labException: '/labs/labException',
    labExceptionById: (eventProductId) => `/labs/labException/${seg(eventProductId)}`,

    // Events
    event: (eventId) => `/event/${seg(eventId)}`,
    eventProductId: '/event_product/event_product_id',

    // Students / users / accounts
    account: (studentId) => `/account/${seg(studentId)}`,
    users: (userId) => `/users/${seg(userId)}`,

    // Products and access
    productAccess: '/product_access',
    productAccessById: (id) => `/product_access/${seg(id)}`,
    accountAccess: '/account_access',
    accountAccessById: (accountId) => `/account_access/${seg(accountId)}`,

    // User cache
    userCache: '/user_cache',
    userCacheById: (accountId) => `/user_cache/${seg(accountId)}`,

    // Analytics (trailing slash before the query is intentional and preserved)
    ovpnDownloads: '/ovpn_downloads/',
    pageVisits: '/page_visits/',
};
